import { Injectable } from '@angular/core';

import { CreateCapitalDepositCompanyState } from './create-capital-deposit-company-state';
import { CreateCompanyState } from './create-company-state';
import { CreateExpertCompanyState } from './create-expert-company-state';
import { CreateLegalCompanyState } from './create-legal-company-state';

export type CreateCompanyStateMode = 'Expert' | 'CapitalDeposit' | 'Legal';

@Injectable({ providedIn: 'root' })
export class CreateCompanyStateFactory {
  create(mode: CreateCompanyStateMode): CreateCompanyState {
    switch (mode) {
      case 'Expert':
        return new CreateExpertCompanyState();
      case 'CapitalDeposit':
        return new CreateCapitalDepositCompanyState();
      case 'Legal':
        return new CreateLegalCompanyState();
    }
  }
}
